import { catchError, of, tap } from "rxjs";

import { Auth } from "@/core/data_sources/models/APIAuth";
import { signIn, signOut } from "@/core/data_sources/services/auth";
import { Store } from "@/core/data_sources/store";
import { requestToObservable } from "@/core/utils/observables";
import { BaseRequestClient } from "@/core/utils/request";

import { AuthState } from "./auth_state";

import type { AuthActions } from "./auth_actions";
import type { AuthHooks } from "./auth_hooks";

export class AuthStore extends Store<AuthState, AuthActions, AuthHooks> {
  private static _instance: AuthStore;

  static get instance() {
    AuthStore._instance = AuthStore._instance || new AuthStore();
    return this._instance;
  }
  private constructor() {
    super(new AuthState(), {
      signIn: (data: { password: string; email: string }) => {
        return requestToObservable(() => {
          return signIn(data);
        }).pipe(
          tap((response) => {
            if (!response?.data) return;
            const auth = new Auth(response.data);
            this.state.addAuth(auth);
            BaseRequestClient.defaults.headers.common["Authorization"] =
              auth.getAuthorizationHeader();
          }),
        );
      },
      signOut: () => {
        return requestToObservable(() => {
          return signOut();
        }).pipe(
          catchError(() => of(null)),
          tap(() => {
            this.state.clear();
          }),
        );
      },
    });
  }
}
